import React from 'react'
import { customSectionAnchorID, PacketCustomSection } from '@marketing-milk/interfaces'
import { SurfacePalette, type } from '../../../tokens'
import { useSectionNumber } from '../../PacketSectionsContext'
import { customSectionKey } from '../../sections'
import { PresentPage } from '../PresentPage'

interface Props {
  palette: SurfacePalette
  packetID: number
  section: PacketCustomSection
}

/**
 * Client-facing render of an AE-authored slide. Identical treatment to
 * `PresentNarrative` — including the empty-body line, because empty is loud and
 * stale is silent.
 *
 * Note what is deliberately absent: the unreviewed marker. The client may be in
 * the room, so "we carried this forward and haven't looked at it" never renders
 * here; it lives in edit mode and on the packet list.
 */
export const PresentCustomSection = ({ palette, packetID, section }: Props) => {
  const number = useSectionNumber(customSectionKey(section.id))
  const text = section.richText.trim()

  return (
    <PresentPage
      palette={palette}
      number={number}
      title={section.title}
      commentAnchor={{
        type: 'section',
        id: customSectionAnchorID(packetID, section.id),
        label: section.title,
      }}
    >
      <div
        style={{
          fontFamily: type.family.serif,
          fontSize: 32,
          lineHeight: 1.4,
          whiteSpace: 'pre-wrap',
          color: text ? palette.text : palette.textFaint,
          fontStyle: text ? 'normal' : 'italic',
          maxWidth: 760,
        }}
      >
        {text || 'Nothing captured for this section.'}
      </div>
    </PresentPage>
  )
}
